export enum EPixSelector {
  Cpf = 1,
  Cnpj,
  Evp,
  Phone,
  Email,
  Checking,
  Savings,
}
